/*!
 * KoliBri - The accessible HTML-Standard
 */
import { b as watchValidator, i as isString } from './common-D-vggmh2.js';

const SAFE_CLASS_NAME_RE = /^[a-zA-Z][a-zA-Z0-9_-]{3,60}$/;
const isValidArrayOrString = (value) => (Array.isArray(value) && value.every(isSafeClassName)) || (isString(value, 1) && value.split(' ').every(isSafeClassName));
const isSafeClassName = (value) => typeof value === 'string' && SAFE_CLASS_NAME_RE.test(value);
const SAFE_CLASS_NAME_ALLOWED = new Set([SAFE_CLASS_NAME_RE.source]);
const beforePatchString = (component) => {
    var _a, _b, _c;
    if ((_a = component.nextState) === null || _a === void 0 ? void 0 : _a.has('_variant')) {
        const variants = (_b = component.nextState) === null || _b === void 0 ? void 0 : _b.get('_variant');
        let nextStateVariants = [];
        if (isString(variants, 1)) {
            nextStateVariants = variants.split(' ');
        }
        else if (Array.isArray(variants)) {
            nextStateVariants = variants;
        }
        (_c = component.nextState) === null || _c === void 0 ? void 0 : _c.set('_variant', nextStateVariants);
    }
};
const validateVariantClassName = (component, value, options = {}) => {
    var _a;
    watchValidator(component, '_variant', isValidArrayOrString, SAFE_CLASS_NAME_ALLOWED, value, Object.assign(Object.assign({}, options), { defaultValue: {}, hooks: {
            afterPatch: (_a = options.hooks) === null || _a === void 0 ? void 0 : _a.afterPatch,
            beforePatch: (nextValue, nextState, component, key) => {
                var _a, _b;
                if (typeof ((_a = options.hooks) === null || _a === void 0 ? void 0 : _a.beforePatch) === 'function') {
                    (_b = options.hooks) === null || _b === void 0 ? void 0 : _b.beforePatch(nextValue, nextState, component, key);
                }
                beforePatchString(component);
            },
        } }));
};
const classNameFromVariant = (variants, componentName) => {
    let className = '';
    if (Array.isArray(variants)) {
        variants.forEach((variant) => {
            className += 'kol-' + componentName + '--' + variant + ' ';
        });
    }
    return className;
};

export { classNameFromVariant as c, validateVariantClassName as v };
//# sourceMappingURL=variant-class-name-9qZ5egaq.js.map

//# sourceMappingURL=variant-class-name-9qZ5egaq.js.map